// extracted by mini-css-extract-plugin
export default {"wrapper":"Socials_wrapper__wNDlI","language":"Socials_language__mZCpw"};